<template>
  <div>
    <apexcharts height="250" type="line" :options="chartOptions" :series="series"></apexcharts>
  </div>
</template>

<script>
import { defineComponent, computed } from "vue";
import VueApexCharts from "vue3-apexcharts";
export default defineComponent({
  components: {
    apexcharts: VueApexCharts,
  },
  props: {
    data: { required: true, type: Object },
  },
  setup(props) {
    const data = computed(() => props.data);
    const headers = computed(() => data.value.map((item) => item.date_coverage));
    const values = computed(() => data.value.map((item) => item.percent));
    const chartOptions = computed(() => {
      return {
        chart: {
          id: "line-date",
          type: "line",
          height: 350,
          zoom: {
            autoScaleYaxis: true,
          },
          toolbar: {
            show: false,
          },
        },
        title: {
          text: "Gráfico de Cobertura de Contactos",
          align: "center",
        },
        stroke: {
          width: 2,
          curve: "smooth",
        },
        colors: ["#ADC6FF"],
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
          style: "hollow",
        },
        xaxis: {
          categories: headers.value,
          title: {
            text: "Dias",
          },
        },
        yaxis: {
          title: {
            text: "Porcentaje de clientes",
          },
        },
        tooltip: {
          x: {
            formatter: function (val) {
              return "Dia: " + val;
            },
          },
          y: {
            formatter: function (val) {
              return val + "%";
            },
          },
        },
      };
    });
    return {
      chartOptions,
      values,
    };
  },
  computed: {
    series() {
      return [
        {
          name: "Cobertura",
          data: this.values,
        },
      ];
    },
  },
});
</script>

<style></style>
